import type { ApolloCache } from '@apollo/client';
import { useEffect, useState } from 'react';

import { useQuery } from 'src/modules/apollo';
import { getDataFromCache } from 'src/modules/apollo/apolloCache';
import * as Schema from 'src/types/graphql';

export const useGetUserDetails = () => {
  const [queryFired, setQueryFired] = useState(false);
  const { data, loading, error } = useQuery(Schema.GetUserDetailsDocument, {
    skip: queryFired,
  });

  useEffect(() => {
    if (!loading && !error && !queryFired && data?.viewer) {
      setQueryFired(true);
    }
  }, [data?.viewer, error, loading, queryFired]);
};

export const getUserDetailsFromCache = <T extends Record<string, any>>(
  cache: ApolloCache<T>,
) => {
  const data = getDataFromCache({
    cache,
    query: Schema.GetUserDetailsDocument,
  });

  return data?.viewer || { _id: '', externalId: '', trackingId: '' };
};
